import { render, staticRenderFns } from "./CreateOrEditStaff.vue?vue&type=template&id=67b6d662&scoped=true&"
import script from "./CreateOrEditStaff.vue?vue&type=script&lang=js&"
export * from "./CreateOrEditStaff.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrEditStaff.vue?vue&type=style&index=0&id=67b6d662&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b6d662",
  null
  
)

export default component.exports